<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="budgetReportItemsFormatted"
              :items-per-page="50"
              item-key="masterCategory"
              sort-by="deviationPercentage"
              :sort-desc=true
              class="elevation-1"
              show-expand
              :search="search"
              :custom-filter="filterOnlyCapsText"
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Budget Report</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-flex xs2 class="pr-3">
                    <v-combobox
                          :items="periodList"
                          label="Select Start Period"
                          item-text="text"
                          v-model="assumptionSelectedStartDate"
                          single-line
                          return-object
                          v-on:change="assumptionStartPeriodChanged"
                        ></v-combobox>
                  </v-flex>
                  <v-flex xs2 class="pr-3">  
                    <v-combobox
                            :items="periodList"
                            label="Select End Period"
                            item-text="text"
                            v-model="assumptionSelectedEndDate"
                            single-line
                            return-object
                            v-on:change="assumptionEndPeriodChanged"
                        ></v-combobox>               
                  </v-flex> 
                  <v-flex xs1></v-flex>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    
                    <v-flex xs12>

                      <v-data-table
                      :headers="categoryHeaders"
                      :items="masterItem.budgetReportCategoryList"
                      :items-per-page="50"
                      item-key="category"
                      sort-by="deviationPercentage"
                      :sort-desc=true
                      class="elevation-1"
                      hide-default-footer
                      >              

                    <template v-slot:item.diffAmountFormatted="{ item }">                            
                      <div v-bind:class="{ expenseAmountExceeded: (item.expenseAmount > item.assumptionAmount) }">
                        {{item.diffAmountFormatted}}             
                      </div>
                    </template>   
                    <template v-slot:item.deviationPercentageFormatted="{ item }">                            
                      <div v-bind:class="{ expenseAmountExceeded: (item.deviationPercentage > 25) }">
                        {{item.deviationPercentageFormatted}}             
                      </div>
                    </template>             
                    
                    </v-data-table>

                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.diffAmountFormatted="{ item }">                            
                <div v-bind:class="{ expenseAmountExceeded: (item.expenseAmount > item.assumptionAmount) }">
                  {{item.diffAmountFormatted}}             
                </div>
              </template>   
              <template v-slot:item.deviationPercentageFormatted="{ item }">                            
                      <div v-bind:class="{ expenseAmountExceeded: (item.deviationPercentage > 25) }">
                        {{item.deviationPercentageFormatted}}             
                      </div>
                    </template> 
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import formatPrice from '../helpers/formatter';
const ASSUMPTIONS_API_URL = 'budgetAssumptions';
const PERIODS_API_URL = 'definitions/periods';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      search: '',
      periodList: [],
      allCategoryList: [],
      assumptionSelectedEndDate: {},
      assumptionSelectedStartDate: {},
      selectedCategoriesFilter: [],
      budgetReportItems: [],
      
    }
  },
  computed: {
    headers () {
      return [
        { text: 'MasterCategory',  sortable: true, value: 'masterCategory'},
        { text: 'Assumption Amount (TRY)',  align: 'right', value: 'assumptionAmountFormatted'  },       
        { text: 'Expense Amount (TRY)', align: 'right',  value: 'expenseAmountFormatted'  },  
        { text: 'Remaining Amount (TRY)', align: 'right',  value: 'diffAmountFormatted'  },
        { text: 'Deviation (%)', align: 'center',  value: 'deviationPercentageFormatted'  },
      ]
    },
    categoryHeaders () {
      return [
        { text: 'Category',  sortable: true, value: 'category'},
        { text: 'Assumption Amount (TRY)',  align: 'right', value: 'assumptionAmountFormatted'  },       
        { text: 'Expense Amount (TRY)', align: 'right',  value: 'expenseAmountFormatted'  },  
        { text: 'Remaining Amount (TRY)', align: 'right',  value: 'diffAmountFormatted'  },
        { text: 'Deviation (%)', align: 'center',  value: 'deviationPercentageFormatted'  },
      ]
    },
    budgetReportItemsFormatted(){
      return this.budgetReportItems.map((item) => {
        item.assumptionAmountFormatted = formatPrice(item.assumptionAmount);
        item.expenseAmountFormatted = formatPrice(item.expenseAmount);
        item.diffAmountFormatted = formatPrice(item.assumptionAmount - item.expenseAmount);
        item.diffAmountPositive = item.assumptionAmount > item.expenseAmount ? item.assumptionAmount - item.expenseAmount : item.expenseAmount  - item.assumptionAmount ;
        item.deviationPercentageFormatted =  formatPrice( (item.assumptionAmount && item.assumptionAmount > 0 ) ?  
              (item.assumptionAmount > item.expenseAmount ? item.assumptionAmount - item.expenseAmount : item.expenseAmount  - item.assumptionAmount) 
              / item.assumptionAmount * 100 : Infinity );
        item.deviationPercentage =   (item.assumptionAmount && item.assumptionAmount > 0 ) ?  
              (item.assumptionAmount > item.expenseAmount ? item.assumptionAmount - item.expenseAmount : item.expenseAmount  - item.assumptionAmount) 
              / item.assumptionAmount * 100 : Infinity ;

        if(item.budgetReportCategoryList){
          item.budgetReportCategoryList.map((x) => {
            x.assumptionAmountFormatted = formatPrice(x.assumptionAmount);
            x.expenseAmountFormatted = formatPrice(x.expenseAmount);
            x.diffAmountFormatted = formatPrice(x.assumptionAmount - x.expenseAmount);
            x.diffAmountPositive = x.assumptionAmount > x.expenseAmount ? x.assumptionAmount - x.expenseAmount : x.expenseAmount  - x.assumptionAmount ;

            x.deviationPercentageFormatted =  formatPrice( (x.assumptionAmount && x.assumptionAmount > 0 ) ?  
              (x.assumptionAmount > x.expenseAmount ? x.assumptionAmount - x.expenseAmount : x.expenseAmount  - x.assumptionAmount) 
              / x.assumptionAmount * 100 : Infinity);
            x.deviationPercentage =   (x.assumptionAmount && x.assumptionAmount > 0 ) ?  
              (x.assumptionAmount > x.expenseAmount ? x.assumptionAmount - x.expenseAmount : x.expenseAmount  - x.assumptionAmount) 
              / x.assumptionAmount * 100 : Infinity ;

            return x;  
          })
        }

        return item;  
      })
    },
    
    formTitle () {
      return this.editedIndex === -1 ? 'New Currency Rate' : 'Edit Currency Rate'
    },
  },
  created() {   
    this.getPerformancePeriodList(); 
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    getBudgetData(startPeriodId,endPeriodId){         
      this.$axios.post(this.$apiurl + ASSUMPTIONS_API_URL+'/budgetReport', {
        startPeriodId: startPeriodId,
        endPeriodId: endPeriodId,
      })
        .then(response => {                                   
            this.budgetReportItems =   response.data;
        })
        .catch(error => {
            console.log(error);
        });   
    },  
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl+PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data;
                this.assumptionSelectedStartDate = this.periodList[0];
                this.assumptionSelectedEndDate =  this.periodList[0];
                this.filterBudget();
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    assumptionStartPeriodChanged(item){    
      this.assumptionSelectedStartDate = item;  
      if(this.assumptionSelectedEndDate){
        this.filterBudget();
      }      
    },
    assumptionEndPeriodChanged(item){
      this.assumptionSelectedEndDate = item;
      if(this.assumptionSelectedStartDate){
        this.filterBudget();
      }  
    },
    filterBudget (){
      if(this.assumptionSelectedStartDate && this.assumptionSelectedEndDate){  
        this.showProgress = true;       
        if(this.selectedCategoriesFilter && this.selectedCategoriesFilter.length > 0){
          selectedFilters = Array.from(this.selectedCategoriesFilter, x => x.code);
        }
        this.getBudgetData(this.assumptionSelectedStartDate.id,this.assumptionSelectedEndDate.id);
      }else{
        alert('Please select Start Date, End Date and Category');
      }
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
<style scoped>
.expenseAmountExceeded{
  color:red;
}
</style>
